import PropTypes from 'prop-types';
import SingleLineMultiSelect from 'infrastructure/js/components/controls/SingleLineMultiSelect/singleLineMultiSelect.js';
import withAsyncProps from 'infrastructure/js/components/HOCs/withAsyncProps';
import withEditor from 'infrastructure/js/components/HOCs/withEditor/withEditor.js';

import './workOrdersAsyncEditor.scss';

const asyncPropsOptions = [
  {
    propName: 'options',
    config: {
      type: 'api',
      connection: {
        url: 'workorders/search/items',
        method: 'post',
        params: { active: true, maxPageSize: 100 },
        valueKey: 'businessId',
        allowEmptyStringValue: false,
      },
      dataTranslator: (response) => {
        if (Array.isArray(response.dataList)) {
          return response.dataList.map(({ id, businessId }) => ({ value: id, label: businessId }));
        } else {
          console.error(response);
          return [];
        }
      },
      onLoad: () => {},
      initialValue: [],
    },
  },
];

const Component = withAsyncProps(withEditor(SingleLineMultiSelect), asyncPropsOptions);

const WorkOrdersAsyncEditor = ({ asset={}, ...props }) => {
  const { startAfterWorkOrdersItems: wosValue } = asset;
  const computedValue = wosValue?.map(({ id, businessId }) => ({ value: id, label: businessId })) || [];

  return <Component {...props} value={computedValue} className='work-order-async-editor' />;
};

WorkOrdersAsyncEditor.propTypes = {
  asset: PropTypes.object,
};

export default WorkOrdersAsyncEditor;
